var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntLayout from "antd/es/layout";
import AntMenu from "antd/es/menu";
import CaretIcon from "../Icons/Caret";
const { Sider } = AntLayout;
const generateMenu = (menu, i) => {
    const key = `sidebar-el-${i}-${menu.title}`;
    return menu.subMenu ? (React.createElement(AntMenu.SubMenu, { key: key + "-sub", icon: menu.icon, title: menu.title }, menu.subMenu.map((m, j) => {
        return generateMenu(m, j);
    }))) : (React.createElement(AntMenu.Item, { icon: menu.icon, key: key }, menu.title));
};
const Sidebar = (_a) => {
    var { children, className, menu, subMenu } = _a, props = __rest(_a, ["children", "className", "menu", "subMenu"]);
    const [collapsed, setCollapse] = useState(false);
    const toggleCollapse = () => setCollapse(!collapsed);
    return (React.createElement(Sider, Object.assign({ className: classNames("gerudo-sidebar", className, {
            "is-collapsed": collapsed,
        }), theme: "light", collapsed: collapsed, breakpoint: ["xl"], onBreakpoint: setCollapse, width: 240 }, props),
        React.createElement("div", { className: "collapse-region" },
            React.createElement("div", { className: classNames("collapser", { collapsed }), onClick: toggleCollapse },
                React.createElement(CaretIcon, null))),
        menu && (React.createElement(AntMenu, { className: "gerudo-sidebar-menu", theme: "dark", mode: "inline" }, menu.map((m, i) => {
            return generateMenu(m, i);
        }))),
        children,
        subMenu && (React.createElement(AntMenu, { className: "gerudo-sidebar-menu footer", theme: "dark", mode: "inline" }, subMenu.map((m, i) => {
            return generateMenu(m, i);
        })))));
};
Sidebar.defaultProps = {
    children: [],
    className: "",
};
const menu = {
    title: PropTypes.node,
    icon: PropTypes.node,
};
menu.subMenu = PropTypes.arrayOf(PropTypes.shape(menu));
Sidebar.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    menu: PropTypes.arrayOf(PropTypes.shape(menu)),
    subMenu: PropTypes.arrayOf(PropTypes.shape(menu)),
};
export default Sidebar;
export { Sidebar };
//# sourceMappingURL=index.js.map